// extracted by mini-css-extract-plugin
export default {"bar":"TopBar_bar__D3sZP","crumbs":"TopBar_crumbs__CbkMX","bellWrap":"TopBar_bellWrap__tJv5a","badge":"TopBar_badge__bVSMM","slot":"TopBar_slot__58qPU"};